import React from "react";
import { Link } from "react-router-dom";
import StaffAnalytics from "../../components/analytics/staffAnalytics";
import StaffAttendanceAnalytics from "../../components/analytics/StaffAttendanceAnalytics";

/**
 * Dedicated Staff analytics page.
 * Mounted at two routes in App.js:
 *   owner: /analytics/staff              -> <StaffAnalyticsPage isPortal={false} />
 *   staff: /staff-panel/analytics/staff  -> <StaffAnalyticsPage isPortal={true} />
 *
 * Staff route is gated with ModuleGuard STAFF_MANAGEMENT + PermissionGuard STAFF_MANAGEMENT_VIEW.
 */
const StaffAnalyticsPage = ({ isPortal = false }) => {
  const homeUrl = isPortal ? "/staff-home" : "/school-home";
  const hubUrl = isPortal ? "/staff-panel/analytics" : "/analytics";

  return (
    <div className="min-h-screen bg-neutral-100 dark:bg-neutral-800 dark:bg-neutral-900">
      <div className="max-w-6xl mx-auto p-6">
        <nav className="mb-4 flex flex-wrap items-center gap-2 text-sm text-neutral-500 dark:text-neutral-400">
          <Link to={homeUrl} className="hover:text-sky-600">
            Home
          </Link>
          <span>/</span>
          <Link to={hubUrl} className="hover:text-sky-600">
            Analytics
          </Link>
          <span>/</span>
          <span className="font-medium text-neutral-800 dark:text-neutral-100">Staff Analytics</span>
        </nav>

        <h1 className="text-2xl font-bold text-neutral-800 dark:text-neutral-100 mb-6">Staff Analytics</h1>

        <div className="space-y-8">
          <StaffAnalytics isPortal={isPortal} />
          <StaffAttendanceAnalytics isPortal={isPortal} />
        </div>
      </div>
    </div>
  );
};

export default StaffAnalyticsPage;
